import React from 'react'
import {Icon} from '@chakra-ui/react'

const ChevronLeftHeaderIcon = (props) => {
    return (
        <Icon viewBox="0 0 16 16" {...props}>
            <path
                id="arrow"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.8054 14C10.7286 14 10.6518 13.9706 10.593 13.9124L4.88825 8.21247C4.83185 8.15607 4.80005 8.07987 4.80005 8.00007C4.80005 7.92028 4.83185 7.84408 4.88825 7.78768L10.593 2.08775C10.7106 1.97075 10.9002 1.97075 11.0178 2.08775C11.1348 2.20535 11.1348 2.39495 11.0178 2.51254L5.52424 8.00007L11.0178 13.4876C11.1348 13.6052 11.1348 13.7948 11.0178 13.9124C10.959 13.9706 10.8822 14 10.8054 14Z"
                fill="white"
            />
        </Icon>
    )
}

export default ChevronLeftHeaderIcon
